export function getRestParamErrorMessage (serverErrorResponse: any, restParamToTestForErrorMessage: string) { 
  let errorMessage: string;
  errorMessage = 
    serverErrorResponse && 
    serverErrorResponse.response && 
    serverErrorResponse.response.data && 
    serverErrorResponse.response.data.errors && 
    serverErrorResponse.response.data.errors[restParamToTestForErrorMessage] && 
    serverErrorResponse.response.data.errors[restParamToTestForErrorMessage].msg ? 
      serverErrorResponse.response.data.errors[restParamToTestForErrorMessage].msg : '';    
    
  return errorMessage;
}
export function getRestResponseErrorMessage (serverErrorResponse: any) { 
  let errorMessage: string;
  errorMessage = 
    serverErrorResponse && 
    serverErrorResponse.response && 
    serverErrorResponse.response.data && 
    serverErrorResponse.response.data.message ? 
    serverErrorResponse.response.data.message : '';        
  return errorMessage;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/utils/serverErrorMessageUtil.ts